import { NodeType } from '@amplify/amp-module';
import InsightsNodeHandler from '../insights-node-handler';
import { evaluateCondition } from './util';

export default class ConditionHandler extends InsightsNodeHandler {
  constructor(ctx) {
    super(ctx, NodeType.condition);
    this.tracking = ctx.$tracking;
  }

  async handleNode(node) {
    await super.handleNode(node, { addToStack: false, handleStorage: false });
    const storageKey = this.store.getters['chatbotStore/getStorageKey'](node.storageKey);

    const conditionMatch = evaluateCondition(
      {
        conditionValue: node.conditionValue,
        storageValue: this.store.getters['chatbotStore/getStorageValue'](storageKey || node.storageKey),
      },
      node.condition
    );

    const outcomeType = conditionMatch ? 'true' : 'false';

    const nextNode = Object.values(this.store.getters['chatbotStore/currentConversation'].nodes).find((n) =>
      n.parentId?.includes(`${node.id}_port_${outcomeType}`)
    );

    if (!node.parentId || node.conversationName) {
      const { name = 'New conversation' } = this.store.getters['chatbotStore/currentConversation'] || {};
      nextNode.conversationName = name;
    }

    this.trackResponseEvent('condition', {
      conditionId: node.id,
      outcomeType: outcomeType.toUpperCase(),
    });

    return nextNode;
  }
}
